import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setGender } from '../../store/slices/authSlice';
import './EncounterGender.css';

const EncounterGender = () => {
  const savedGender = useSelector(state => state.auth.gender);
  const [selectedGender, setSelectedGender] = useState(savedGender || '');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const options = [
    { value: 'F', label: t('yourGender.options.women') },
    { value: 'M', label: t('yourGender.options.men') }
  ];

  const handleNext = () => {
    if (!selectedGender) return;
    dispatch(setGender(selectedGender));
    navigate('/rencontre/recherche');
  };

  return (
    <main className="encounter-gender-page">
      <header className="encounter-gender-header">
        <img
          src="/assets/img/fulllogo_transparent_nobuffer.png"
          alt="Trakna"
          className="encounter-gender-logo"
        />
        <Link className="encounter-login-link" to="/login">
          Se connecter
        </Link>
      </header>

      <section className="encounter-gender-card">
        <img
          src="/assets/img/onboarding/pic1.png"
          alt="Faites de nouvelles rencontres avec Trakna"
          className="encounter-gender-visual"
        />

        <div className="encounter-gender-content">
          <p className="encounter-gender-eyebrow">Commençons votre profil</p>
          <h1>{t('yourGender.title')}</h1>

          <div className="encounter-gender-options" role="radiogroup" aria-label={t('yourGender.title')}>
            {options.map(option => (
              <label
                key={option.value}
                className={`encounter-gender-option ${selectedGender === option.value ? 'selected' : ''}`}
              >
                <input
                  type="radio"
                  name="encounterGender"
                  value={option.value}
                  checked={selectedGender === option.value}
                  onChange={() => setSelectedGender(option.value)}
                />
                <span>{option.label}</span>
              </label>
            ))}
          </div>

          <button
            type="button"
            className="encounter-gender-next"
            disabled={!selectedGender}
            onClick={handleNext}
          >
            {t('yourGender.next')}
          </button>

          <p className="encounter-gender-member">
            Déjà membre ? <Link to="/login">Se connecter</Link>
          </p>
        </div>
      </section>
    </main>
  );
};

export default EncounterGender;
